module.exports = __webpack_public_path__ + "img/conductor-save.20312a05.svg";